import { DocumentTemplate, DOCUMENT_COMPOSITIONS } from '../../../shared/documents';
import './LdaDocument.scss';

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString('fr-FR');
};

const getValue = (source, ...keys) => keys.reduce((result, key) => (
  result !== undefined && result !== null && result !== '' ? result : source?.[key]
), undefined);

const getClientName = (project) => {
  const client = project?.Client || project?.client || project?.company || {};
  return getValue(client, 'socialReason', 'social_reason', 'name', 'legalName', 'legal_name')
    || getValue(project, 'clientName', 'client_name')
    || '';
};

const getProjectAddress = (project) => [
  getValue(project, 'address_line1', 'addressLine1'),
  getValue(project, 'address_line2', 'addressLine2'),
].filter(Boolean).join(' · ');

const getCode = (row) => row.codeGed || row.code_ged || row.title || '';
const getLot = (row) => row.lot || row.lot_code || '—';
const getPhase = (row) => row.phase || row.phase_code || '—';
const getIndex = (row) => row.indice || '—';
const getStartDate = (row) => row.forecastStartDate || row.forecast_start_date;
const getDeliveryDate = (row) => row.deliveryDate || row.delivery_date || row.forecast_delivery_date;
const getDiffusionDate = (row) => row.diffusionDate || row.diffusion_date;
const getPlannedResource = (row) => row.plannedResourceName || row.planned_resource_name || '—';

export const buildLdaDocumentMetadata = (project = {}) => ({
  projectName: project.name || project.label || 'Projet',
  projectReference: project.code || project.reference || project.projectCode || project.project_code || '',
  client: getClientName(project),
  projectAddress: getProjectAddress(project),
  phase: 'LDA',
  documentDateLabel: new Date().toLocaleDateString('fr-FR'),
  status: 'issued',
});

export default function LdaDocument({ project = {}, rows = [] }) {
  const deliverables = rows.filter((row) => !row.parentId && !row.parent_id);
  const metadata = buildLdaDocumentMetadata(project);

  return (
    <DocumentTemplate composition={DOCUMENT_COMPOSITIONS.REGISTER} title="Liste des documents applicables" metadata={metadata}>
      <section className="erp-document-section lda-document-summary">
        <div>
          <strong>{deliverables.length}</strong>
          <span>livrable{deliverables.length > 1 ? 's' : ''}</span>
        </div>
        <div>
          <strong>{deliverables.filter((row) => String(row.status || '').toLowerCase() === 'diffusé' || String(row.status || '').toLowerCase() === 'diffuse').length}</strong>
          <span>diffusé{deliverables.length > 1 ? 's' : ''}</span>
        </div>
      </section>

      <section className="erp-document-section">
        <h2>Registre des livrables</h2>
        <table className="erp-document-table lda-document-table">
          <thead>
            <tr>
              <th className="lda-document-table__code">Référence</th>
              <th>Désignation</th>
              <th className="lda-document-table__compact">Phase</th>
              <th className="lda-document-table__compact">Lot</th>
              <th className="lda-document-table__compact">Indice</th>
              <th className="lda-document-table__status">Statut</th>
              <th className="lda-document-table__date">Début</th>
              <th className="lda-document-table__date">Échéance</th>
              <th className="lda-document-table__date">Diffusion</th>
              <th className="lda-document-table__assignee">Ressource prévue</th>
              <th>Observations</th>
            </tr>
          </thead>
          <tbody>
            {deliverables.length ? deliverables.map((row) => (
              <tr key={row.id || getCode(row)}>
                <td><code>{getCode(row) || '—'}</code></td>
                <td><strong>{row.title || row.denomination || '—'}</strong></td>
                <td>{getPhase(row)}</td>
                <td>{getLot(row)}</td>
                <td>{getIndex(row)}</td>
                <td>{row.status || '—'}</td>
                <td>{formatDate(getStartDate(row))}</td>
                <td>{formatDate(getDeliveryDate(row))}</td>
                <td>{formatDate(getDiffusionDate(row))}</td>
                <td>{getPlannedResource(row)}</td>
                <td>{row.observations || '—'}</td>
              </tr>
            )) : (
              <tr><td colSpan="11">Aucun livrable enregistré.</td></tr>
            )}
          </tbody>
        </table>
      </section>
    </DocumentTemplate>
  );
}
